module.exports = __webpack_public_path__ + "static/media/heart.27b40c8c.svg";